import React, { Fragment, useEffect, useState, useContext } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import * as Constants from "../../../data/StringConstants";
import FoldersTable from "../../../components/Table/FoldersTable";
import AppContext from "../../../data/AppContext";
import { FoldersApi } from '../../../api/folders/folders';

/**
 * @exports
 * @description This container is responsible for data fetching and rendering of corresponding sub-components
 * for the 'My Folders' view which lists all promotions (folders) that were created by the user
 * currently viewing the page.
 */
export default function MyFoldersContainer(props) {
	const folderState = { data: [], totalItemCount: 0, isLoading: true };
	const [resp, setData] = useState(folderState);
	const appContext = useContext(AppContext);
	const queryParams = { userId: appContext.user.UserID };
	// How many folders per page
	const shownFolderCount = 100;
	useEffect(() => {
		let isCancelled = false;

		FoldersApi.fetchAllActiveFoldersForAUser(queryParams)
			.then(resp => {
				const newState = {
					data: resp.data,
					totalItemCount: resp.data.length,
					isLoading: false
				};
				!isCancelled && setData(newState);
			})
			.catch(err => console.log(Constants.NO_FOLDERS_RESP_ERR, err));
		return () => (isCancelled = true);
	}, []);

	return resp.isLoading ? <LoadingSpinner /> :
		<FoldersTable
			data={resp.data}
			shownFolderCount={shownFolderCount}
			{...props}
		/>
}
